import { camelcaseKeys } from '@shared-runtime/utils/keys';

import type { GetFiatUserAccessResult } from './apiSchema';
import type { FiatUserAccessResponse } from './schema';

export function normalizeGetFiatUserAccess(
  data: GetFiatUserAccessResult,
): FiatUserAccessResponse {
  const userAccess = data.accesses.map((item: any) => camelcaseKeys(item));
  const getCurrencyAccess = (currency: string) =>
    userAccess?.filter((service: any) => service.currency === currency);

  const hasFiatAccess = userAccess?.length > 0;
  const hasUSDAccess = getCurrencyAccess('USD').length > 0;
  const hasUSDDepositAccess = getCurrencyAccess('USD').some(
    (service: any) => service.isDepositEnable,
  );
  const hasUSDWithdrawAccess = getCurrencyAccess('USD').some(
    (service: any) => service.isWithdrawEnable,
  );
  const hasEURAccess = getCurrencyAccess('EUR').length > 0;
  const eurService: any = getCurrencyAccess('EUR')[0];
  const hasEURDepositAccess = eurService?.isDepositEnable;
  const hasEURWithdrawAccess = eurService?.isWithdrawEnable;
  const hasGBPAccess = !!(getCurrencyAccess('GBP').length > 0);
  const gbpService: any = getCurrencyAccess('GBP')[0];
  const hasGBPDepositAccess = !!gbpService?.isDepositEnable;
  const hasGBPWithdrawAccess = !!gbpService?.isWithdrawEnable;
  const hasAEDAccess = getCurrencyAccess('AED').length > 0;
  const aedService: any = getCurrencyAccess('AED')[0];
  const hasAEDDepositAccess = !!aedService?.isDepositEnable;
  const hasAEDWithdrawAccess = !!aedService?.isWithdrawEnable;

  return {
    items: userAccess,
    hasFiatAccess,
    hasUSDAccess,
    hasUSDDepositAccess,
    hasUSDWithdrawAccess,
    hasEURAccess,
    hasEURDepositAccess,
    hasEURWithdrawAccess,
    hasGBPAccess,
    hasGBPDepositAccess,
    hasGBPWithdrawAccess,
    hasAEDAccess,
    hasAEDDepositAccess,
    hasAEDWithdrawAccess,
  };
}
